import { useCallback, useMemo } from "react";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";
import dayjs from "../../../../../configs/dayjs";

export const useFormatData = (granularity: number) => {
  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const typesMap: any = useMemo(
    () => ({
      ACH: {
        name: "ACH",
        weight: 1,
      },
      ECheck: {
        name: "ECheck",
        weight: 2,
      },
      Check: {
        name: "Check",
        weight: 3,
      },
      CreditCard: {
        name: "Credit Card",
        weight: 4,
      },
      FromImpound: {
        name: "From Impound",
        weight: 5,
      },
      FromEscrow: {
        name: "From Escrow Account",
        weight: 6,
      },
      External: {
        name: "External Payment",
        weight: 7,
      },
      WireTransfer: {
        name: "Wire Transfer",
        weight: 4,
      },
      GeneralLedger: {
        name: "General Ledger",
        weight: 5,
      },
      AchChecking: {
        name: "ACH Checking",
        weight: 1,
      },
      AchSaving: {
        name: "ACH Saving",
        weight: 2,
      },
      ToEscrow: {
        name: "To Escrow Account",
        weight: 6,
      },
    }),
    [],
  );

  const formatData = useCallback(
    (data: any) => {
      const res: any[] = [];

      data
        .sort((a: any, b: any) => {
          const type1: string = a.code.split(".")[2];
          const type2: string = b.code.split(".")[2];

          return typesMap[type2].weight - typesMap[type1].weight;
        })
        .forEach((item: any) => {
          const type: string = item.code.split(".")[2];

          item.kpiValues.forEach((val: any) => {
            const dot: any = { type: typesMap[type].name };

            dot.yAxis = val.value;
            dot.xAxis = dayjs(val.createdAt).format(xAxisFormat);
            dot.tooltipHeader = dayjs(val.createdAt).format(tooltipFormat);

            res.push(dot);
          });
        });

      return res.reverse();
    },
    [xAxisFormat, typesMap, tooltipFormat],
  );

  return { formatData };
};
